export default {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    upload: 'Upload',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    passwordConfirmation: 'Password Confirmation',
    isCommunityManager: 'Community Manager',
    dashboard: 'Dashboard',
    offerLists: 'Offer Lists',
    schedule: 'Schedule',
    accountEdit: 'Account Edit',
    edit: 'Edit',
    detail: 'Detail',
    fullname: '{{firstname}} {{lastname}}',
    quantity: 'Quantity',
    quantityWithWeight: 'Quantity (Weight)',
    confirmTitle: 'Confirmation',
    orderInformation: 'Pre-order information',
    orderPrices: 'Price change history',
    invoices: 'Invoices',
    contact: 'Contact Us',
    when: 'When',
    add_to_google_calendar: 'Add to Google Calendar',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: 'Unpaid invoices (10 unpaid invoices are displayed order by expired date)',
                totalUnpaidAmountAll: 'Unpaid invoices(all)',
                totalUnpaidAmountExpired: 'Unpaid invoices(expired)',
                more: 'view all',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection residency status',
                chartTitleFromImported: 'imported to purchased',
                chartTitleFromPurchased: 'purchased to delivered',
                within1month: 'within 1month',
                within2month: 'within 2months',
                within3month: 'within 3months',
                within4month: 'within 4months',
                within5month: 'within 5months',
                over5month: 'over 5month',
                unitLabel: 'Weight(Kg)',
            },
            remainingWarehouseItems: {
                title: 'Pending status of pre-orders (Lump-sum payment after the initial delivery or Pay per delivery)',
                subTitles: {
                    byPeriod: 'By Period',
                    byCommunityManager: 'By Community manager',
                    byOffice: 'By Office',
                },
                more: 'view all',
                unitLabel: 'Weight(Kg)',
            },
        },
        offerUpload: {
            title: 'Upload CSV',
            producer: 'Producer',
            download: 'Download CSV template',
            sampleDeliveryDateMemo: 'Must be 14 days before the desired publication date.',
            uploadMemo: 'A representative will contact you later after the upload is complete',
            suggestToCreateBankAccountText: "You must provide a bank account to receive your sales proceeds.\nIt is necessary when issuing a Sales Contract.We recommend that you fill in the following blanks when you upload your offer list.",
        },
        offerList: {
            title: 'Offer List for {{country}} / {{ name }}',
            createInvoices: 'Create Invoices',
            createInvoicesExplanation: "Invoices will be issued in a lump sum for pre-order that have been registered and for which the payment timing is set to \"1. lump-sum payment as requested by the producer.\n      However, if an invoice has already been issued for the ordered, no new invoice will be created.\n      The URL of the invoice will be sent to each roaster by e-mail.",
            sampleOrderStock: {
                quantity: 'Sample stock by office',
                lotVisibleLabel: 'Show/Hide Lot',
                show: 'Show',
                hide: 'Hide',
            },
            publishedCountriesTableTitle: 'Country of Sale',
            basicInformations: 'Basic information',
            publishedCountriesTable: 'Country of Sale',
            transportToWarehouseTable: 'Warehouse Unit Transport Information',
            officeDetailTable: 'Office Information',
            offersTable: 'Offers',
            contracts: 'Contracts',
            sampleOrderPeriod: 'Sample requesting period',
            orderPeriod: 'Pre-order requesting period',
            paymentPeriod: 'Payment period',
            estimatedDeliveryPeriod: 'Estimated delivery period',
            paymentAfterDelivery: 'Payment after delivery',
            paymentPeriods: {
                reserved: 'On order confirmation',
                exported: 'On departure from origin',
                imported: 'On arrival at destination',
                delivered: 'On delivery',
            },
            installmentPaymentAfterImport: 'Multiple installments after warehouse arrival',
            installmentPayment: 'installments',
            estimatedPaymentDateFormat: '{{date}} {{month}} {{year}}',
            installmentPaymentsHelp: {
                title: 'About payment after delivery',
                body: "If you have selected \"Payment after delivery\" at the time of the pre-order, you will pay after the product has been delivered.\nYou can choose to pay in full after the first delivery, or you can choose to pay per delivery of the goods in the storage.",
            },
            FreeOnBoardHelp: {
                title: 'About FOB',
                body: "It's the price of green coffee at the time of arrival at a port of origin.\nOcean freight rates and import fees are not included.",
            },
            warehouseItemHelp: {
                title: 'About delivery requests',
                body: 'Product available for release after receipt of first payment.',
            },
            estimatedDeliveryPeriodFormat: '{{monthPart}} {{month}} {{year}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: 'OKAGESAMA Contributors',
            okagesamaNoMoriTotalPrices: 'OKAGESAMA Total prices',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA Statuses',
                joined: 'Joined',
                paid: 'Joined(Paid)',
            },
        },
        editProfile: {
            title: 'Edit Account Information',
            subTitle: 'Your information',
            questionnairesForRoaster: 'Roaster-related questions',
            questionnairesForRoasterMemo: '* The following information can be updated later.',
            cannotChangeCountry: '* Please note that once a country is registered, it cannot be changed',
        },
        editAccount: {
            title: 'Edit Account Information',
            currentEmail: 'Current email address',
            warning: "After editing the account information, you will be logged out once.\nA confirmation email will be sent to your new email address.\nClick the link provided there to complete the account change.\nAfter that, you can log in with your new email address.",
        },
        exchangeRates: {
            title: 'Exchange Rate Settings',
            exchangeRateColumnTitle: 'USD to {{ currency }}',
        },
        roasterOfferLists: {
            sampleRequest: 'Sample Request',
            order: 'Pre-order',
            inactive: 'Expired',
        },
        roasterOrder: {
            title: 'Pre-order from {{ listName }}',
            explanationSelectOffers: 'Please check the available quantity in the list below and select the pre-order quantity.',
            explanationAuctionWithFobPriceUsdPerLb: 'Auction results are in USD/Kg. (1kg=2.20462lb)',
            explanationStockMightChange: 'Please be aware that remaining stock might change while navigating this page.',
            order: 'Pre-order',
            orderAmount: 'Pre-order',
            totalFee: 'Total cost: {{ fee }} (tax included)',
            totalBags: 'Total bags: {{ amount }}',
            totalOrderedBags: 'Total bags ordered: {{ amount }}',
            totalWeight: 'Total weight: {{ weight }}Kg',
            totalOrderedWeight: 'Total weight ordered: {{ weight }}Kg',
            totalOneTimeUpfrontOrderedBags: 'Total bags ordered with prepayment discount: {{ amount }}',
            typicaHandlingFee: 'TYPICA handling fee: {{ percentage }}%',
            typicaHandlingFeeExplanationByBagCount: 'less than 5 bags: {{ lessThan5Bags }} / 5 to 10 bags: {{ moreThan5Bags }} / 10 to 49 bags: {{ moreThan10Bags }} / 50 or more bags: {{ moreThan50Bags }}',
            typicaHandlingFeeExplanationByWeight: 'Under 300kg: {{ lessThan300Kg }} / 300kg and above: {{ moreThan300Kg }} / 600kg and above: {{ moreThan600Kg }} / 3,000kg and above: {{ moreThan3000Kg }}',
            details: 'Details',
            paymentAndDelivery: 'Payment method and delivery address',
            paymentMethodExplanation: "* The maximum transaction limit and the terms of installment payment vary between users. Please contact your credit card company for details.\n      * Please be aware that if the total amount of a single invoice has more than 8 integer digits, the payment method might be changed to bank transfer automatically.",
            endOfMonth: 'By the end of',
            oneTimeUpfrontExplanations: '- Payment is due {{ paymentDate }}. Please check the invoice issued after the offer is closed for more details.',
            afterImportPaymentExplanations: "- Payment Net 14 from warehouse arrival (estimation: {{ deliveryPeriod }})\n      - Product available for release after receipt of payment.",
            fewTimesPaymentAfterImportExplanations: "- First payment Net 14 from warehouse arrival (estimation: {{ deliveryPeriod }}).\n      - Product available for release after receipt of first payment.\n      - Subsequent payments are due at the end of each month following the month of warehouse arrival. Please check the invoice issued at the beginning of each month for more details.",
            paymentTimingExplanation: '* Processing fees vary depending on the timing of payment. Use the price simulator at the bottom of the page for details.',
            oneTimeUpfrontRateConstraintByBagAmount: ' (only for orders of 2 or more bags)',
            oneTimeUpfrontRateConstraintByWeight: ' (only for orders of 120kg and above)',
            deliveryMethodExplanation: "* A storage fee of {{unitPrice}} per 1kg per month will be charged from the first day of the second month after the item is received in our warehouse.",
            oneTimeUpfrontRateByBagAmount: '(A {{ percentage }} discount applied. * only for orders of 2 or more bags)',
            oneTimeUpfrontRateByWeight: ' | -{{ percentage }} Discount',
            paymentTimingNegativeRate: ' | -{{ percentage }} Discount',
            paymentTimingPositiveRate: ' | {{ positive }}{{ percentage }} Financing Fee',
            addressExplanation: '* Please be sure to enter your building name and room number if necessary.',
            emailExplanation: '* Please make sure to enter your email address correctly',
            deliveryTimeEtcExplanation: '* Please note that we may not be able to meet the requests for a specific delivery time.',
            sample: 'Sample',
            sampleOrder: 'Sample request',
            outOfSamples: 'Out of samples',
            sampleOrdered: 'Requested',
            bidSubmitted: 'Bid Submitted',
            sampleOrderableCount: 'Pre-orderable sample amount',
            inputAddress: 'Input address',
            simulateAndInputAddress: 'Details and input address',
            simulation: 'Price simulation',
            sampleOrderCaption: 'Following Lot sample will be pre-ordered',
            comment: 'Comment',
            commentHelp: '* Your comment will be shared to other roasters and producers',
            translation: 'Your comments can be translated into English, Spanish, Japanese, Chinese and Korean.',
            postComment: 'Post comment',
            updateComment: 'Update comment',
            deleteComment: 'Delete comment',
            noComments: 'No comments',
            cuppingScoreHelpText: 'Please fill in your score on SCA cupping form',
            more: 'More info',
            ordered: 'Pre-ordered',
            addInvoice: 'Create invoice',
            preOrderExplanation: 'The pre-order period is planned to be {{startedAt}} - {{endedAt}}.',
            countdownToOrder: '{{countdown}} before pre-order',
            confirmationOfBuyPartial: 'Withdraw bid if Lot:{{lotNumber}} is not available in desired quantity',
            auctionBadgeExplanation: "This lot is on offer at a blind auction.\nPlease enter your desired price and quantity.\nAny amount above the starting price will go to the producer as an auction bonus.\nThe bidding result will be e-mailed at a later date.\nThe figure in the badge shows the number of bidders at of now.",
            okagesamaNoMoriPrice: '* Participation fee {{ priceUsd }} (Around {{ price }})',
            okagesamaNoMoriPriceText: '(Subject to exchange rates)',
            sampleStats: 'roasters interested in this producer',
            preorderStats: 'roasters ordered from this producer',
        },
        ordersPage: {
            title: 'Pre-orders',
            detailsTitle: 'Pre-orders details',
        },
        sampleOrdersPage: {
            title: 'Sample Requests',
        },
        register: {
            accept: 'Agree to Terms',
        },
        orderedOfferLists: {
            title: 'Pre-ordered offer lists',
        },
        sampleOrders: {
            title: 'Sample Requests',
            import: 'Import sample requests',
        },
        sampleOrderedOfferLists: {
            title: 'Sample Requested Offer Lists',
        },
        orderDetail: {
            orderItemsTableTitle: 'Pre-ordered Lots',
            bidsTableTitle: 'Your Bids',
            changeStatus: 'Change status',
            preOrderRequestCreateOrEdit: 'Create/edit request',
        },
        sampleOrderDetail: {
            requestedLotNumbers: 'Requested Lot numbers',
        },
        invoice: {
            title: 'Invoice for order {{orderIds}}',
            billingTo: 'Billing to',
            billingAddress: 'Billing address',
            transparencyInformation: {
                farm: 'Producer',
                farmExplanation: 'For information about the producer please see <1>here</1>.',
                mill: 'Mill',
                millExplanation: 'Coffee cherries and parchment purchased from producers are processed in local mills. This includes the cost of domestic delivery and customs clearance in the country of production.',
                auctionBonus: 'Auction Bonus',
                auctionBonusExplanation: 'All of the proceeds above the starting price will go to producers as an auction bonus.',
                shippingFee: 'Freight',
                shippingFeeExplanation: 'This is the total of freight and import costs (customs clearance, phytosanitary application fees, etc.).',
                importTax: 'Import tax',
                importTaxExplanation: '{{ importTaxRate }} of the freight costs and the price of the goods.',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'Handling charge for TYPICA ({{exclusiveTypicaHandlingRate}})',
                typicaExplanationByBagCount: 'Handling charge for TYPICA. (0-5 bags: {{ lessThan5Bags }}, 5-9 bags: {{ moreThan5Bags }}, 10-49 bags: {{ moreThan10Bags }}, more than 50 bags: {{ moreThan50Bags }})',
                typicaExplanationByWeight: 'Handling charge for TYPICA. (Under 300kg: {{ lessThan300Kg }}, 300kg and above: {{ moreThan300Kg }}, 600kg and above: {{ moreThan600Kg }}, 3,000kg and above: {{ moreThan3000Kg }})',
                typicaExplanationForTypicaSelection: 'Handling charge for TYPICA (40%)',
                typicaExplanationForTypicaSelectionByWeightV1: 'Handling charge for TYPICA. (Under 300kg: 40%, 300kg and above: 35%, 600kg and above: 30%, 3,000kg and above: 25%)',
                typicaExplanationForTypicaSelectionByWeightV2: 'Handling charge for TYPICA. (Under 300kg: 35%, 300kg and above: 25%, 600kg and above: 20%, 3,000kg and above: 15%)',
                consumptionTaxExplanation: '{{ taxRate }} of taxable costs and fees.',
                vatReverseChargeExplanation: 'VAT Reversed Charge(0%) applied.',
                oldPriceVersionKgPriceNotice: 'This kg price excludes "Handling cost for installment payments (not taxed)", "Prepayment discount" and "Service fee (not taxed)".',
                newPriceVersionKgPriceNotice: 'Price per kilogram, excluding early payment discount or late payment surcharge',
                specialTypicaDiscount: 'Discount',
                specialTypicaDiscountExplanation: 'This is the total discount amount.',
                shippingFeeForJp: 'Overseas Shipping Costs',
                shippingFeeExplanationForJp: 'This is the cost from the port of loading to the port/airport of unloading.',
                importTaxForJp: 'Import and Transport Costs',
                importTaxExplanationForJp: 'Total transport and import costs from the port of discharge to the warehouse, including fees for customs clearance and plant quarantine applications.',
                consumptionTaxExplanationForJp: 'This is the total taxable amount, at a rate of 8% for green coffee beans and 10% for overseas shipping costs and other expenses.',
                CoffeeCherryExplanation: 'Remarks',
                negativeBreakdownCoffeeCherryExplanation: 'As the cost of cherries of in Ethiopia continues to rise, it becomes increasingly difficult for washing stations, mills and exporters to stay profitable. {{producerName}}, however, believes that building long-term partnerships with roasters is important in the overall sustainability of the industry and so, in valuing those relationships, will be offering their coffee at an average price of the last few years, rather than raising it significantly.',
            },
            paidStatus: 'Payment status',
            paidMessage: 'Paid on {{paidDate}}.',
            unpaidMessage: 'Unpaid. Please pay by {{expiredDate}}.',
            changePaymentMethod: 'Change payment method',
            vatrcHelp: 'Enter your VAT number on the profile screen and the VAT Reversed Charge will be applied.',
        },
        adminUsers: {
            title: 'Users',
        },
        adminRoasters: {
            title: 'Roasters',
            typicaShareRatioCalculatedAt: 'TYPICA share ratio calculated at',
        },
        adminRoasterDetail: {
            title: 'Details for {{roaster}}',
        },
        adminProducers: {
            title: 'Producers',
        },
        adminProducerDetail: {
            title: 'Details for {{producer}}',
        },
        countryInformations: {
            title: 'Country of Origin',
        },
        roasterCountries: {
            title: 'Country of Sale',
        },
        adminOrder: {
            title: 'Proxy ore-order',
            selectRoaster: 'Select Roaster',
        },
        warehouses: {
            title: 'Warehouse Management',
        },
        warehouseItems: {
            title: 'Warehouse Stock',
            deliveryRequest: 'Delivery request',
            addressInfo: 'Address information',
            selectItems: 'Please select the Lot which you want to request for delivery',
            explainationForQuantity: 'The quantity listed is the number of items in the shipment, not the number of items pre-order',
            editDeliveryRequest: {
                caption: 'Do you need to change your delivery schedule?',
                button: 'Edit delivery schedule',
            },
        },
        deliveryRequests: {
            title: 'List of Delivery Requests',
            import: 'Input delivery charges in a batch',
        },
        deliveryRequestDetail: {
            title: 'Delivery request details',
            basicInfo: 'Basic information',
            editForm: 'Edit form',
        },
        newDeliveryRequest: {
            title: 'Add New Delivery Request',
        },
        roasterWarehouseItems: {
            requestable: 'Requestable',
            delivered: 'Delivered',
            delivering: 'Delivery in progress',
        },
        offerListForum: {
            translateMessage: 'Translate message',
            changeTranslationLanguage: 'Change translation language',
            languages: {
                en: 'English',
                es: 'Spanish',
                ja: 'Japanese',
                zh: 'Chinese',
                ko: 'Korean',
            },
        },
        monthlyClosing: {
            title: 'Monthly Closings',
            createButton: 'Execute monthly closing',
        },
        balanceSheetEntry: {
            title: 'Balance Sheet Entries',
            advanceReceived: 'Advance Received',
        },
        offices: {
            title: 'Office',
        },
        invoicePayment: {
            title: 'Payment for invoice "{{invoiceTitle}}"',
            suspendedMessage: "I'm very sorry\n\nWe regret to inform you that we are temporarily suspending credit card payments due to the migration of our payment system.\nPlease wait a while for the migration process. Please make your payment after the migration of the payment system is completed. Or if you are in a hurry, please make your payment by bank transfer.\n",
        },
        transportToWarehouse: {
            waterActivity: 'Water activity',
            moistureContent: 'Moisture content',
        },
        adminAuction: {
            title: 'Auction Status for {{offerListName}} / {{lotNumber}}',
            auctionClosed: 'Auction Closed',
            auctionOpened: 'Auction Ongoing',
            closeAuction: 'Close Auction',
            confirmation: 'This auction will be closed. Bids cannot be canceled after the auction is closed. Do you want to proceed?',
        },
        roasterBids: {
            title: 'Bids',
        },
        roasterAuction: {
            title: 'Results for {{offerListName}} / {{lotNumber}}',
            bidQuantity: 'Quantity Secured',
            roasterAuctionResult: 'Bidding Results',
            auctionResult: 'All Bidding Results',
        },
        adminCreateTypicaStockItems: {
            title: 'Create TYPICA Selection Stock',
        },
        adminTypicaStockItems: {
            title: 'TYPICA Selection Stock',
            helpQuantity: 'The total number of typica stock. This value is reflected when creating contracts such as Shipping instructions.',
            helpRemainingQuantity: 'Quantity - Ordered Quantity + Adjustment Quantity',
            helpAdjustmentQuantity: 'For adjusting the number of items in typica stock (e.g., to reduce the number of items in stock for sample requests)',
            helpSampleRemainingQuantity: 'Sample total quantity - Sample ordered quantity',
        },
        adminNewTypicaStockOrder: {
            title: 'Proxy pre-order from TYPICA Selection',
        },
        adminTypicaStockOrders: {
            title: 'TYPICA Selection pre-orders',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICA Selection sample requests',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'Producer Bank account information for salesContract',
        },
        producerBankAccounts: {
            title: 'List of Bank Accounts',
            edit: 'Edit Bank Account Information',
            new: 'Add New Bank Account',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'Roaster Sales Reward',
            netWeight: 'Weight',
            quantity: 'Quantity',
        },
        typicaSelection: {
            title: 'TYPICA Selection',
            order: 'View more details',
            sampleOrderPeriod: 'Always',
            orderPeriod: 'Always',
            paymentPeriod: 'Payment after delivery',
            estimatedDeliveryPeriod: 'About one week after order',
            sampleOrder: 'Click here to request a sample',
            orderFormStepper: {
                order: 'Payment & billing address',
                deliveryRequest: 'Delivery specifications',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: 'No delivery date provided',
                        body2: 'Please provide a delivery date',
                    },
                    installment: {
                        body1: 'There are remaining lots available for delivery requests.',
                        body2: 'Please specify all delivery periods for partial delivery',
                    },
                },
                isNotWarehousing: {
                    body1: 'Not at the warehouse yet',
                    body2: "You cannot specify a delivery period for lots that haven't arrived at the warehouse",
                },
                inValidDeliveryRequestItemsAndRequestDate: 'Please enter the amount of deliveries or the designated delivery date',
            },
        },
        preOrderRequest: {
            title: 'Your request for repeat order',
            new: 'Create a new request for repeat order',
            requestedOffer: 'Requested for repeat order Lot',
            lotNumberBlank: 'Request from the same offer list',
        },
        roasterAddresses: {
            title: 'Address book',
            billingAddresses: 'Billing addresses',
            deliveryAddresses: 'Delivery addresses',
        },
        cuppingComments: {
            title: 'Cupping Summary',
            commentedBy: 'Contributed by',
            otherRoasters: 'and {{ count }} other roasters',
        },
        createCuppingComment: {
            title: 'Create Comment',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: 'Delivery schedule',
            subheaders: {
                oneTime: 'Bulk delivery will be made during the estimated delivery window.',
                installment: 'Delivery will be divided into a maximum of three installments from the estimated delivery period.',
                installmentCaption: 'Estimated delivery: About one week after pre-order',
            },
            type: {
                oneTime: 'Bulk delivery',
                installment: 'Partial delivery',
            },
            changeTimings: 'Change to {{ timing }}',
            buttons: {
                new: 'Set delivery period',
                add: 'Add delivery period',
            },
            captions: {
                datePicker: {
                    fastestDelivery: '* If left blank, the delivery will be made in the shortest possible time.',
                    main: {
                        deliveryDateExplanation: '* You can set a delivery date as early as {{ startWeek }} from now, and up to 5 months after your delivery request.',
                        startWeek1: '1 week',
                        startWeek2: '2 weeks',
                    },
                    sub: {
                        europe: '* Regarding the designated delivery date, the actual delivery may be delayed by about 2 weeks on average depending on the region, so we recommend that you specify the delivery date as soon as possible. Please note.',
                        etc: '* Regarding the specified delivery date, the actual delivery may be delayed by about a week depending on the region, so we recommend specifying the delivery date as soon as possible. Please note.',
                    },
                },
                card: '* Kindly note that the actual delivery may vary by approximately one week, depending on the region. We suggest selecting an earlier delivery date to accommodate any possible delays. Thank you for your understanding.',
            },
            dialog: {
                title: 'Delivery period',
            },
        },
        adminWarehouseHoliday: {
            title: 'Warehouse holidays',
        },
        exportCsv: {
            title: 'CSV Download',
        },
    },
    labels: {
        stock: 'Available',
        stockUnit: 'Bags',
        lotRef: 'LOT',
        offerListSummary: 'Offer Summary',
        farmWithLink: 'Farm',
        curatorName: 'Curator name',
        seller: 'Seller',
        story: 'Narrative',
        material: 'Materials',
        period: 'Offer period',
        activeOfferLists: 'Available',
        preparingOfferLists: 'Preparing',
        expiredOfferLists: 'Finished',
        noData: 'No data',
        paymentTimingOnAdmin: 'When to pay',
        fullAddress: 'Address',
        deliveryItems: 'Delivery Items (Lot: Quantity)',
        all: 'All',
        inStock: 'In Stock',
        forum: 'Forum',
        forumDisplayName: 'Forum Display Name',
        taxed: 'Tax applies',
        paymentTimingHandlingFee: {
            negativeValue: 'Discounts',
            positiveValue: 'Financing Fee',
        },
        paid: 'Paid',
        exported: 'Exported',
        imported: 'Imported',
        uploadContract: 'Select contract file',
        uploadDocuments: 'Select document file',
        uploadBusinessNumberKrdocument: 'Select image file',
        selectFoundingCurator: 'Input Founding curator name',
        pending: 'Pending',
        newRoasterCampaignDiscount: 'First Order Discount',
        couponTarget: 'Coupon code applied',
        newRoasterCampaignUnderway: 'Promo for first-time users!',
        agree: 'Agree',
        memo: 'Memo',
        tradeCountryUsages: 'Planned use ',
        tradeCountryProcessings: 'Processing method',
        tradeCountryPriceRanges: 'Price range /1kg',
        uneditableJoinedInOkagesamaNoMori: 'Cannot edit joined in OKAGESAMA with active offer lists',
        contributedToOkagesamaNoMori: "* You've already contributed to this OKAGESAMA project",
        default: 'Default',
        billingAddress: 'Billing address',
        deliveryAddress: 'Delivery address',
        deliveryRequestFormRequestDate: 'Specify delivery date',
        fastestDeliveryRequest: 'Fastest delivery',
        deliveryRequestByDate: 'Delivery by date',
        includesItems: 'Include invoice items',
        bulkDownloadMode: 'Bulk download mode',
        miscFeeForJp: 'Misc fee total *2',
        taxNodeForJpCalculation: '*1: 8% taxed / *2: 10% taxed / *3: not taxable',
    },
    buttons: {
        yes: 'Yes',
        no: 'no',
        create: 'Create',
        update: 'Update',
        delete: 'Delete',
        cancel: 'Cancel',
        apply: 'Apply',
        complete: 'Submit',
        resetPassword: 'Reset password',
        changePassword: 'Change password',
        reconfirmEmail: 'Reconfirm Email',
        chooseFile: 'Choose File',
        upload: 'Upload',
        calculateFixed: 'Fix Prices',
        cancelFixed: 'Cancel Fix Prices',
        pay: 'Mark as paid',
        unpay: 'Mark as unpaid',
        downloadInvoice: 'Download invoice',
        salesContractDownloadPdf: 'Download Sales Contract pdf',
        auctionBonusInvoiceDownloadPdf: 'Download Auction Bonus Invoice pdf',
        downloadCsv: 'Download CSV',
        deliveryRequest: 'Request to deliver',
        processing: 'Processing...',
        import: 'Import',
        addItem: 'Add Item',
        createContracts: 'Create Contract',
        changeStatusTo: 'Change status to {{status}}',
        setBankAccount: 'Set Bank Account Information',
        bankAccount: 'Bank Account Information',
        selectFoundingCurator: 'Select Founding curator',
        changeFoundingCurator: 'Change Founding curator',
        deleteFoundingCurator: 'Cancel Founding curator',
        salesReward: 'Sales Reward',
        manageCommunityManager: 'Manage Community Manager',
        stripePayment: 'Pay',
        taiwanApiResponse: {
            resend: 'Resend(Government Uniform Invoices)',
            update: 'Set success without resend(Government Uniform Invoices)',
            destroy: 'Remove success(Government Uniform Invoices)',
        },
        priceDetail: 'View more details',
        setAsDefault: 'Set as default',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        next: 'Next',
        updateNow: 'Update now',
        downloadOffersCsv: 'Download all lots',
    },
    links: {
        login: 'Login from here',
        register: 'Register from here',
        resetPassword: 'Reset password from here',
        reconfirmEmail: 'Resend verification email from here',
        back: 'Back',
        payFromHere: 'Click here to pay',
        story: 'Narrative',
        movie: 'Movie',
        privacy_policy: 'Privacy Policy',
        specified_commercial_transactions_law: 'About the info based on the Japan act of specified commercial transactions',
        tos: 'Terms of service',
        trackingUrl: 'Transportation status',
        cookiePolicy: 'Cookie Policy',
    },
    messages: {
        registerSuccess: 'We have sent an email to {{ email }} to confirm the validity of your email address. Please follow the link in the email to complete your registration.',
        confirmationSuccess: 'Account confirmation successful. Please login with the confirmed email and password.',
        unlockSuccess: 'Your account has been unlocked.',
        resetPasswordSuccess: 'You will receive an email with instructions on how to reset your password in a few minutes.',
        accountUpdateSuccess: 'You will receive an email with instructions how to confirm your new email',
        changePasswordSuccess: 'Password changed successfully',
        reconfirmEmailSuccess: 'Email reconfirm request send, please check your email for instructions',
        deleteConfirm: 'Delete it. Are you really sure?',
        rejectConfirm: 'This will cancel the bid for failing the screening. Are you really sure?',
        bidCancelConfirm: 'Are you sure you want to cancel your bid?',
        invalidEmail: 'Email format is not valid',
        invalidPostalCode: 'Please use only numbers for the postal code',
        loginSuccess: 'Logged in successfully',
        logoutSuccess: 'Logged out successfully',
        uploadSuccess: 'CSV upload successful',
        createSuccess: 'Created successful',
        updateSuccess: 'Updated successful',
        deleteSuccess: 'Deleted successful',
        updateFailure: 'Updated failed',
        orderSuccess: 'Pre-order successful',
        typicaStockOrderSuccess: 'Order successful. You can request delivery from the warehouse stock list for items already in stock.',
        sampleOrderSuccess: 'Sample request successful',
        deliveryRequestSuccess: 'Delivery request successful. We will contact you later regarding the delivery date.',
        cancelConfirm: 'You cannot undo the cancellation. Are you really sure?',
        calculateFixed: "This will approve the pre-order request from the roaster and conclude the sales contract.\nPlease make sure the amount is correct.\nAre you sure you want to finalize the price?",
        cancelFixed: "This will cancel the sales contract established with the roasters.\nThere are risks involved in breaking the contract.\nAre you sure you want to cancel?",
        calculateFixedSuccess: 'Fixed prices for related pre-order',
        cancelFixedSuccess: 'Canceled to fix prices for related pre-order',
        commentSuccess: 'Commented',
        deleteCommentConfirmTitle: 'Delete Comment',
        deleteCommentConfirmBody: 'Delete comment. Are you really sure?',
        changePasswordTokenError: 'Password reset token is expired. Please reset password again.',
        deleteInvoiceConfirmTitle: 'Delete Invoice',
        deleteInvoiceConfirmBody: 'Delete invoice, Are you really sure?',
        deleteInvoiceItemConfirmTitle: 'Delete Invoice Item',
        deleteInvoiceItemConfirmBody: 'Delete invoice item, Are you really sure?',
        sendInvoiceMailConfirmTitle: 'Send Mail',
        sendInvoiceMailConfirmBody: 'Send mail for this invoice to roaster. Are you really sure?',
        sentSuccess: 'Email sent successfully',
        payConfirmTitle: 'Mark as paid',
        payConfirmBody: 'Mark as paid. Are you really sure?',
        unpayConfirmTitle: 'Mark as unpaid',
        unpayConfirmBody: 'Mark as unpaid. Are you really sure?',
        nRowsSelected: '{0} row(s) selected',
        noDeliveryRequest: 'No delivery requests',
        invalidOrderCombination: 'Sample request and pre-order can not be done at the same time',
        orderExplanationTitle: 'Notes on pre-orders',
        sampleOrderExplanationTitle: 'Notes on sample requests',
        auctionOrderExplanationTitle: 'Notes on Auction Pre-orders',
        sampleOrderExplanationBody: "Due to limited sample quantities, only those who wish to purchase are eligible for sample requests.\nWe host community cuppings around the world where you can try all lots.\nPlease check our email announcement for details.",
        deliveryTimeExplanationTitle: 'Our shipping policy',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n* Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n* Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n* Delivery could be delayed by logistical problems.\n* Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "* Shipping fees to be charged.\n* Delivery could be delayed by logistical problems.\n* Please feel free to ask if you have any questions.\n* Extra fees to be charged for delivery from our warehouse in the Netherlands.\n* Our delivery partner CTS Group will deliver your order to your roastery.\n* To check shipping fees, please see <0>this file</0>.\n* In compliance with EU regulation, bags weighing 23kg or more will be put on pallets.\n* Your order will be delivered as Non-Stackable. So no other parcels will be placed on top.\nShipping fees start from three-fourths of a Euro-pallet.",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n* Pre-order pricing is ex-warehouse.\nThere are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\nPlease see <1>this file</1> for delivery costs by destination in NYC area.\nKindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n* An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n* The quality of the product shall be the same as the sample.\n\n* As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n* Extra fees will be added for delivery from our warehouse in the Netherlands. Please see <1>this file</1> to see the delivery costs.\n\n* An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n* The quality of the product shall be the same as the sample.\n\n* As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        createdInvoices: '{{count}} invoices have been created',
        orderNotStarted: 'Pre-order starts from {{ startedAt }}',
        createContractsTitle: 'Preparation of contract documents',
        createContractsBody: "This will create the templates for the contract documents.\nPlease make sure that you have not forgotten to create TYPICA Stock.\nDo you want to proceed?",
        changeContractStatusToPublished: 'Set to Published. If you make it issued, it will be published to the producer and you will be notified by email. Are you sure?',
        changeContractStatusToDraft: 'Set to draft. Are you sure?',
        salesContractDownloadExplanationTitle: 'Before downloading Sales Contract',
        salesContractDownloadExplanationBody: "Before downloading the Sales Contract, you need to fill in your bank account information.\n    Please select your bank account information and include any additional notes, if any.",
        addBankAccountInformation: "To download the Sales Contract, you must register your bank account information.\n    Please register your bank account information at the following link.",
        createBankAccount: 'Your bank account information has been successfully created',
        orderedOfferNotExist: 'No pre-order found',
        stripeConfirmBody: 'Are you ready to confirm payment?',
        updateSuccessInvoicePaid: 'Payment complete. Your invoice status will be changed accordingly.It may take a while.',
        deliverySampleWarningMessage: 'The samples will be shipped out upon arrival at a warehouse. They are due to arrive at a warehouse on {{ approvalDate }}.',
        deliverySampleWarningConfirmationMessage: 'The following samples will be shipped out after they arrive at a warehouse.',
        contactToTypicaMessage: 'Please send your inquiries to the e-mail address below:',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: 'Select Columns',
        exchangeRateMoreThanHighestRateOnPrevMonth: 'The exchange rate exceeds the highest rate ({{ rate }}) for the previous month. Are you sure?',
        exchangeRateLessThanLowestRateOnPrevMonth: 'The exchange rate is below the lowest rate ({{ rate }}) of the previous month. Are you sure?',
        updateRequired: 'New version {{ version }} found! Reload after 5 seconds...',
        newPlatformRegisterNotice: 'We transitioned to a new platform on August 6, 2024. If you would like to register, please click <0>here</0>',
        newPlatformNotice: "We'll transition to the new platform from August 6, 2024. To visit, click <0>here</0>.",
        newPlatformSampleNotice: 'The sample request list on the new platform is <0>here</0>.',
        newPlatformOrderNotice: 'The pre-order list on the new platform is <0>here</0>.',
        newPlatformInvoiceNotice: 'Invoices on the new platform are <0>here</0>.',
        newPlatformProfileNotice: "Changes made here will not be automatically transferred to the new platform.\nWe apologize for the inconvenience, but please update your information on <0>the new platform</0> as well.",
    },
    errors: {
        isRequired: '{{ field }} is required',
        invalid: '{{ field }} is invalid',
        positive: '{{ field }} must be greater than zero',
        integer: '{{ field }} must be integer',
        decimal: '{{ field }} must be a number and decimal',
        alphanumeric: '{{ field }} must be alphanumeric',
        invalidPostalCode: 'Postal code must be alphanumeric 7 characters',
        invalidCity: 'City must be 12 double-byte characters or less',
        invalidAddress: '{{ field }} must be full-width {{ fullWidthMaxLength }} character/half-width {{ halfWidthMaxLength }} character or less',
        purchaseLimitError: 'This Lot can only be pre-order up to {{limit}}',
        lowestBidFobPriceError: 'Please enter a number above the starting price',
        totalFeeUpperLimitError: 'Your order exceeds the maximum limit for credit card payment.Please change your payment method to bank transfer, or adjust the total amount to have 8 integer digits or less.',
        noStock: 'Insufficient stock',
        sameTypicaStockItemExists: 'Same Lot and warehouse combination already exists',
        mustOverOfferMinOrderWeight: 'The weight must be  {{ minOrder }} or higher',
        notSelectableLessThanOrdersTotalWeight120Kg: 'Available for pre-orders of 120 kg or above',
        zeroDeliveryFeeMessage: 'This lot should be processed with a delivery fee of 0',
        mustBeZeroDeliveryFee: 'This lot requires the delivery fee to be set to 0',
        hasTargetWarehouseItemMessage: 'Note: This contains items that should have a delivery fee of 0',
    },
    options: {
        isExists: {
            '1': 'Yes',
            '0': 'Not',
        },
        isQGrader: {
            '1': 'Licensed',
            '0': 'Not Licensed',
        },
    },
    stripePayment: {
        failure: 'Payment failed. Please try again from the beginning.',
        afterStatusSucceeded: 'Payment already complete. It may take a while before your invoice status is changed correctly.',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
    admin: {
        exportCsv: {
            title: 'CSV Download',
            labels: {
                officeLabel: 'Office',
                fromDateLabel: 'Start Date',
                toDateLabel: 'End Date',
                downloadButton: 'Download',
            },
            errors: {
                invalidDateFormat: 'Please enter a valid date format',
                toDateBeforeFromDate: 'End date cannot be earlier than start date',
            },
            taxReturns: {
                title: 'Tax Returns CSV',
            },
            accountingData: {
                title: 'Accounting Data CSV',
            },
            deliveryFee: {
                title: 'Delivery Fee CSV',
            },
            warehouseFee: {
                title: 'Warehouse Fee CSV',
            },
            offerList: {
                title: 'Offer List CSV',
            },
            pendingWarehouseFee: {
                title: 'Unbilled Warehouse Fee CSV',
            },
        },
    },
};
